import classNames from 'classnames';
import { memoize } from 'lodash';
import * as React from 'react';

import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import {
    ActionsMenu,
    ActionsMenuGroup,
    ActionsMenuProps
} from '../ActionsMenu/ActionsMenu';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { Shape2Icon } from '../Shape2/Shape2';

import './GridActionsMenu.css';

export interface GridActionsMenuItem {
    body: React.ReactNode;
    type: string;
    disabled: boolean;
    disabledTooltip?: string;
}

export interface GridActionsMenuItems {
    items: Array<GridActionsMenuItem>;
    title?: string;
}

export interface GridActionsMenuProps {
    actions: Array<GridActionsMenuItems>;
    events: Record<string, () => void>;
    cls?: string;
}

const BLOCK = 'grid-actions-menu';

const ActionMenuPopupContainer = makeGridPopupContainer<ActionsMenuProps>(
    ActionsMenu
);

export class GridActionsMenu extends React.PureComponent<GridActionsMenuProps> {
    private getActions = memoize(
        (actions: Array<GridActionsMenuItems>): Array<ActionsMenuGroup> => {
            return actions.map(actionObj => {
                return {
                    title: actionObj.title,
                    items: actionObj.items.map(action => ({
                        text: this.renderMenuOption(action),
                        val: action.type,
                        elemMods: { disabled: action.disabled }
                    }))
                };
            });
        }
    );

    onItemSelect = (
        event: React.MouseEvent<HTMLElement>,
        val: string
    ): void => {
        this.props.events[val]();
    };

    render() {
        const { cls, actions } = this.props;

        return (
            <ActionMenuPopupContainer
                className={classNames(
                    Bem.cls(BLOCK),
                    // TODO: DIRECT-97275 прятать тестовые классы в проде
                    TestBem.cls(BLOCK),
                    cls
                )}
                onItemSelect={this.onItemSelect}
                actions={this.getActions(actions)}
                icon={Shape2Icon.settings}
                popupPosition="right-alt"
                isLink={true}
            />
        );
    }

    private renderMenuOption(item: GridActionsMenuItem) {
        // TODO: DIRECT-97275 прятать тестовые классы в проде
        const action = (
            <span className={TestBem.cls(BLOCK, 'action')}>{item.body}</span>
        );

        if (item.disabled && item.disabledTooltip) {
            return (
                <HoverTooltipWrapper
                    to={['right', 'left']}
                    tooltipText={item.disabledTooltip}
                >
                    {action}
                </HoverTooltipWrapper>
            );
        }
        return action;
    }
}
